/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { Formulario, Titulo, downloadFile, formatFecha, tituloBase } from "../../../shared";

import { Toast } from "primereact/toast";
import { Card } from "primereact/card";

export default function Reporte() {
  const [loaderBoton, setLoaderBoton] = useState(false);
  const [loaderBotonClientes, setLoaderBotonClientes] = useState(false);
  const [loaderBotonSeguimientos, setLoaderBotonSeguimientos] = useState(false);
  const toast = useRef(null);

  useEffect(() => {
    document.title = "Reportes";
    return () => (document.title = tituloBase());
  }, []);

  function procesarCertificadosPorNorma(camposFormulario) {
    setLoaderBoton(true);
    let url;
    let filename;
    if (camposFormulario.fechaInicio && camposFormulario.fechaFinalizacion) {
      url = `admin/reporte/oua/procesospornorma/${camposFormulario.fechaInicio}/${camposFormulario.fechaFinalizacion}`;
      filename = `Certificados ${formatFecha(
        camposFormulario.fechaInicio
      )} - ${formatFecha(camposFormulario.fechaFinalizacion)}.xlsx`;
    } else {
      url = `admin/reporte/oua/procesospornorma`;
      filename = "Certificados.xlsx";
    }

    downloadFile(
      url,
      filename,
      () => {
        setLoaderBoton(false);
      },
      (respuesta) => {
        setLoaderBoton(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al descargar el reporte",
          sticky: true
        });
      }
    );
  }

  function procesarClientesPorNorma(camposFormulario) {
    setLoaderBotonClientes(true);
    let url;
    let filename;
    if (camposFormulario.fechaInicio && camposFormulario.fechaFinalizacion) {
      url = `admin/reporte/oua/clientespornorma/${camposFormulario.fechaInicio}/${camposFormulario.fechaFinalizacion}`;
      filename = `Clientes por norma ${formatFecha(
        camposFormulario.fechaInicio
      )} - ${formatFecha(camposFormulario.fechaFinalizacion)}.xlsx`;
    } else {
      url = `admin/reporte/oua/clientespornorma`;
      filename = "Clientes por norma.xlsx";
    }

    downloadFile(
      url,
      filename,
      () => {
        setLoaderBotonClientes(false);
      },
      (respuesta) => {
        setLoaderBotonClientes(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al descargar el reporte",
          sticky: true
        });
      }
    );
  }

  function procesarSeguimientosUrsea(camposFormulario) {
    setLoaderBotonSeguimientos(true);

    downloadFile(
      `admin/reporte/ursea/seguimientos/${camposFormulario.fechaInicio}/${camposFormulario.fechaFinalizacion}`,
      `Seguimientos URSEA ${formatFecha(camposFormulario.fechaInicio)} - ${formatFecha(
        camposFormulario.fechaFinalizacion
      )}.xlsx`,
      () => {
        setLoaderBotonSeguimientos(false);
      },
      (respuesta) => {
        setLoaderBotonSeguimientos(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al descargar el reporte",
          sticky: true
        });
      }
    );
  }

  const OUACertificadosPorNormaFormConfig = {
    secciones: [
      {
        nombre: "Certificados por norma",
        campos: [
          {
            nombre: "fechaInicio",
            tipoitemformularioid: 7,
            etiqueta: "Fecha de inicio"
          },
          {
            nombre: "fechaFinalizacion",
            tipoitemformularioid: 7,
            etiqueta: "Fecha de finalización"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Obtener certificados",
        callback: procesarCertificadosPorNorma,
        validar: true
      }
    ]
  };

  const OUAClientesPorNormaFormConfig = {
    secciones: [
      {
        nombre: "Clientes por norma",
        campos: [
          {
            nombre: "fechaInicio",
            tipoitemformularioid: 7,
            etiqueta: "Fecha de inicio"
          },
          {
            nombre: "fechaFinalizacion",
            tipoitemformularioid: 7,
            etiqueta: "Fecha de finalización"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Obtener clientes",
        callback: procesarClientesPorNorma,
        validar: true
      }
    ]
  };

  const URSEASeguimientosFormConfig = {
    secciones: [
      {
        nombre: "Seguimientos",
        campos: [
          {
            nombre: "fechaInicio",
            tipoitemformularioid: 7,
            etiqueta: "Fecha de inicio",
            requerido: true
          },
          {
            nombre: "fechaFinalizacion",
            tipoitemformularioid: 7,
            etiqueta: "Fecha de finalización",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Obtener seguimientos",
        callback: procesarSeguimientosUrsea,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Titulo urlVolver="/config">Reportes para OUA</Titulo>

      <div className="grid">
        <div className="col-12 lg:col-6">
          <Card>
            <Formulario
              config={OUACertificadosPorNormaFormConfig}
              loader={loaderBoton}
              formularioEnCuerpo
            />
          </Card>
        </div>

        <div className="col-12 lg:col-6">
          <Card>
            <Formulario
              config={OUAClientesPorNormaFormConfig}
              loader={loaderBotonClientes}
              formularioEnCuerpo
            />
          </Card>
        </div>
      </div>

      <Titulo>Reportes para URSEA</Titulo>

      <div className="grid">
        <div className="col-12 lg:col-6">
          <Card>
            <Formulario
              config={URSEASeguimientosFormConfig}
              loader={loaderBotonSeguimientos}
              formularioEnCuerpo
            />
          </Card>
        </div>
      </div>
    </>
  );
}
